<template>
  <div class="d-flex justify-start align-center mt-1">
    <BaseActionsButton
      id="editProject"
      name="editProject"
      iconName="mdi-pencil"
      iconColor="primary"
      customClass="mr-2"
      tooltipMessage="Edit Details"
      @click="editProject()"
    ></BaseActionsButton>
  </div>
</template>

<script>
export default {
  methods: {
    editProject() {
      this.params.context.parentComponent.editProject(this.params.data.id);
    },
  },
};
</script>

<style>
</style>